import classNames from "classnames";

import type {ISearchComboboxMetricsProps} from "../types/ISearchComboboxMetricsProps";

import * as styles from "./SearchComboboxMetrics.module.css";

const hasValue = (value: unknown) => value !== undefined && value !== null && value !== false && value !== "";

/**
 * Right-hand column of a row: price over transactions (`stacked`, rows) or transactions before price on one line
 * (`inline`, building numbers). An optional `primaryHint` follows the price on its line ("· 2025 r."). A stacked
 * column with transactions only promotes them to the main line; the inline one keeps the caption style so a lazily
 * loaded price does not make the line jump. `alignColumns` (inline) puts the price and the hint in fixed-width slots.
 */
export const SearchComboboxMetrics = (props: ISearchComboboxMetricsProps) => {
    const {primary, primaryHint, secondary, layout = "stacked", isPrimaryMuted, alignColumns, className} = props;
    const hasPrimary = hasValue(primary);
    const hasSecondary = hasValue(secondary);

    if (!hasPrimary && !hasSecondary) {
        return null;
    }

    const isInline = layout === "inline";
    const isAligned = isInline && alignColumns === true;
    const isPromoted = !isInline && !hasPrimary;
    const hasHint = hasPrimary && hasValue(primaryHint);
    const primaryValueNode =
        hasPrimary || isAligned ? (
            <span className={classNames(styles.primary, isPrimaryMuted && styles.primaryMuted)}>{hasPrimary ? primary : null}</span>
        ) : null;
    const primaryNode =
        hasHint || isAligned ? (
            <span className={styles.primaryGroup}>
                {primaryValueNode}
                <span className={styles.primaryHint}>
                    {hasHint ? (
                        <>
                            <span className={styles.primaryHintDot} aria-hidden="true">
                                ·
                            </span>{" "}
                            {primaryHint}
                        </>
                    ) : null}
                </span>
            </span>
        ) : (
            primaryValueNode
        );
    const secondaryNode = hasSecondary ? <span className={classNames(styles.secondary, isPromoted && styles.secondaryPromoted)}>{secondary}</span> : null;

    return (
        <span className={classNames(styles.metrics, isInline ? styles.metricsInline : styles.metricsStacked, isAligned && styles.metricsAligned, className)}>
            {isInline ? secondaryNode : primaryNode}
            {isInline ? primaryNode : secondaryNode}
        </span>
    );
};
import classNames from "classnames";

import type {ISearchComboboxMetricsProps} from "../types/ISearchComboboxMetricsProps";

import * as styles from "./SearchComboboxMetrics.module.css";

const hasValue = (value: unknown) => value !== undefined && value !== null && value !== false && value !== "";

/**
 * Right-hand column of a row: price over transactions (`stacked`, rows) or transactions before price on one line
 * (`inline`, building numbers). An optional `primaryHint` follows the price on its line ("· 2025 r."). A stacked
 * column with transactions only promotes them to the main line; the inline one keeps the caption style so a lazily
 * loaded price does not make the line jump. `alignColumns` (inline) puts the price and the hint in fixed-width slots.
 */
export const SearchComboboxMetrics = (props: ISearchComboboxMetricsProps) => {
    const {primary, primaryHint, secondary, layout = "stacked", isPrimaryMuted, alignColumns, className} = props;
    const hasPrimary = hasValue(primary);
    const hasSecondary = hasValue(secondary);

    if (!hasPrimary && !hasSecondary) {
        return null;
    }

    const isInline = layout === "inline";
    const isAligned = isInline && alignColumns === true;
    const isPromoted = !isInline && !hasPrimary;
    const hasHint = hasPrimary && hasValue(primaryHint);
    const primaryValueNode =
        hasPrimary || isAligned ? (
            <span className={classNames(styles.primary, isPrimaryMuted && styles.primaryMuted)}>{hasPrimary ? primary : null}</span>
        ) : null;
    const primaryNode =
        hasHint || isAligned ? (
            <span className={styles.primaryGroup}>
                {primaryValueNode}
                <span className={styles.primaryHint}>
                    {hasHint ? (
                        <>
                            <span className={styles.primaryHintDot} aria-hidden="true">
                                ·
                            </span>{" "}
                            {primaryHint}
                        </>
                    ) : null}
                </span>
            </span>
        ) : (
            primaryValueNode
        );
    const secondaryNode = hasSecondary ? <span className={classNames(styles.secondary, isPromoted && styles.secondaryPromoted)}>{secondary}</span> : null;

    return (
        <span className={classNames(styles.metrics, isInline ? styles.metricsInline : styles.metricsStacked, isAligned && styles.metricsAligned, className)}>
            {isInline ? secondaryNode : primaryNode}
            {isInline ? primaryNode : secondaryNode}
        </span>
    );
};
